import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import PipelessFiltration from "@/pages/PipelessFiltration";
import WhyChooseUs from "@/pages/WhyChooseUs";
import Contact from "@/pages/Contact";
import Booking from "@/pages/Booking";
import Admin from "@/pages/Admin";
import SwimmingPoolConstruction from "@/pages/SwimmingPoolConstruction";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import LuxuryVillaPools from "@/pages/services/LuxuryVillaPools";
import CommercialPools from "@/pages/services/CommercialPools";
import PoolWaterproofing from "@/pages/services/PoolWaterproofing";
import PoolMaintenanceAMC from "@/pages/services/PoolMaintenanceAMC";
import JacuzziSpa from "@/pages/services/JacuzziSpa";
import CanonicalTag from "@/components/CanonicalTag";
import WhatsAppButton from "@/components/WhatsAppButton";
import MobileStickyBar from "@/components/MobileStickyBar";
import LeadPopup from "@/components/LeadPopup";

function AppLayout() {
  const location = useLocation();
  const isAdmin = location.pathname === '/admin';

  return (
    <>
      <CanonicalTag />
      {!isAdmin && <Header />}
      <main className={isAdmin ? '' : 'pt-[70px] lg:pt-[100px]'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/pipeless-filtration" element={<PipelessFiltration />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/booking" element={<Booking />} />
          <Route path="/swimming-pool-construction" element={<SwimmingPoolConstruction />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/services/luxury-villa-swimming-pools" element={<LuxuryVillaPools />} />
          <Route path="/services/commercial-swimming-pool-construction" element={<CommercialPools />} />
          <Route path="/services/pool-waterproofing-sopremapool" element={<PoolWaterproofing />} />
          <Route path="/services/pool-maintenance-amc" element={<PoolMaintenanceAMC />} />
          <Route path="/services/jacuzzi-spa-installation" element={<JacuzziSpa />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <MobileStickyBar />}
      {!isAdmin && <LeadPopup />}
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
